/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { LoginConfig } from "./login.config";
import { LoginService } from './login.service';

@Injectable()
export class LoginGuard implements CanActivate {
    constructor(private loginService: LoginService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> | boolean {
      let userInfo = this.loginService.GetSessionUserInfo();
      if (this.loginService.IsSignedIn(userInfo)) {
        sessionStorage.loginCompleteUrl = "";
        return true;
      }
      sessionStorage.loginCompleteUrl = location.href;
      this.router.navigate([LoginConfig.getFormattedPath(this.loginService.app_path, 'loginflow', true)]);
      return false;
  }
}
